import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2e9a6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = ["placeholder", "disabled"]
const _hoisted_7 = {
  key: 0,
  class: "column"
}
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = ["placeholder", "disabled"]
const _hoisted_12 = {
  key: 1,
  class: "column"
}
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "control" }
const _hoisted_16 = { class: "select is-fullwidth" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { value: "" }
const _hoisted_19 = { value: "Dog" }
const _hoisted_20 = { value: "Cat" }
const _hoisted_21 = { value: "Other" }
const _hoisted_22 = {
  key: 2,
  class: "column"
}
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "control" }
const _hoisted_26 = ["placeholder", "disabled"]
const _hoisted_27 = {
  key: 3,
  class: "column"
}
const _hoisted_28 = { class: "field" }
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "control" }
const _hoisted_31 = { class: "select is-fullwidth" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "columns" }
const _hoisted_35 = { class: "column" }
const _hoisted_36 = { class: "field" }
const _hoisted_37 = { class: "label" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = { class: "select is-fullwidth" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { value: "" }
const _hoisted_42 = { value: "F" }
const _hoisted_43 = { value: "M" }
const _hoisted_44 = { class: "column" }
const _hoisted_45 = { class: "field" }
const _hoisted_46 = { class: "label" }
const _hoisted_47 = { class: "control" }
const _hoisted_48 = { class: "column" }
const _hoisted_49 = { class: "field" }
const _hoisted_50 = { class: "label" }
const _hoisted_51 = { class: "control" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { key: 4 }
const _hoisted_57 = { key: 5 }
const _hoisted_58 = { class: "column" }
const _hoisted_59 = { class: "field" }
const _hoisted_60 = { class: "label" }
const _hoisted_61 = { class: "control" }
const _hoisted_62 = { class: "select is-fullwidth" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { value: "" }
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "column" }
const _hoisted_67 = { class: "field" }
const _hoisted_68 = { class: "label" }
const _hoisted_69 = { class: "control" }
const _hoisted_70 = ["placeholder", "disabled"]
const _hoisted_71 = { class: "field is-grouped is-grouped-right" }
const _hoisted_72 = {
  key: 0,
  class: "control"
}
const _hoisted_73 = {
  key: 1,
  class: "control"
}
const _hoisted_74 = {
  key: 2,
  class: "control"
}
const _hoisted_75 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_76 = {
  key: 3,
  class: "control"
}
const _hoisted_77 = { class: "content-body" }
const _hoisted_78 = {
  class: "table-container mb-2",
  style: {"max-height":"280px","overflow-y":"auto"}
}
const _hoisted_79 = {
  key: 0,
  class: "table"
}
const _hoisted_80 = { style: {"position":"sticky","top":"0","z-index":"10","background-color":"white"} }
const _hoisted_81 = { class: "sticky-column" }
const _hoisted_82 = { class: "" }
const _hoisted_83 = { class: "" }
const _hoisted_84 = { class: "" }
const _hoisted_85 = { class: "" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_AppointmentDataPetRecordTableRow = _resolveComponent("AppointmentDataPetRecordTableRow")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editPetMeth && _ctx.editPetMeth(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('PetData.PetName')), 1),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              minlength: 2,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getDetailedPetData.name) = $event)),
              ref: "petname",
              class: "input",
              type: "text",
              placeholder: _ctx.$t('PetData.PetNamePlaceholder'),
              disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager'),
              required: ""
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.getDetailedPetData.name]
            ])
          ])
        ])
      ]),
      (_ctx.otherSpecies)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('PetData.Species')), 1),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  id: "species_field",
                  minlength: 2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getDetailedPetData.species) = $event)),
                  class: "input",
                  type: "text",
                  placeholder: _ctx.$t('PetData.SpeciesPlaceholder'),
                  disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager'),
                  required: "",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSpecies(_ctx.getDetailedPetData.species)))
                }, null, 40, _hoisted_11), [
                  [_vModelText, _ctx.getDetailedPetData.species]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.otherSpecies)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('PetData.Species')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    id: "species_dropdown",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getDetailedPetData.species) = $event)),
                    required: "",
                    class: "px-6",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSpecies(_ctx.getDetailedPetData.species))),
                    disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager')
                  }, [
                    _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('General.PleaseChoose')), 1),
                    _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('PetData.SpeciesDog')), 1),
                    _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t('PetData.SpeciesCat')), 1),
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('PetData.SpeciesOther')), 1)
                  ], 40, _hoisted_17), [
                    [_vModelSelect, _ctx.getDetailedPetData.species]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.otherSpecies || _ctx.otherBreed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('PetData.Breed')), 1),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  minlength: 2,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.getDetailedPetData.breed) = $event)),
                  class: "input",
                  type: "text",
                  placeholder: _ctx.$t('PetData.BreedPlaceholder'),
                  required: "",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateBreed(_ctx.getDetailedPetData.breed))),
                  disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager')
                }, null, 40, _hoisted_26), [
                  [_vModelText, _ctx.getDetailedPetData.breed]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.otherSpecies && !_ctx.otherBreed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('PetData.Breed')), 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.getDetailedPetData.breed) = $event)),
                    required: "",
                    class: "px-6",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateBreed(_ctx.getDetailedPetData.breed))),
                    disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager')
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEditedCustBreeds, (breed) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: breed.breed_id,
                        value: breed.name
                      }, _toDisplayString(breed.name), 9, _hoisted_33))
                    }), 128))
                  ], 40, _hoisted_32), [
                    [_vModelSelect, _ctx.getDetailedPetData.breed]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('PetData.Gender')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.getDetailedPetData.gender) = $event)),
                required: "",
                class: "px-6",
                disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager')
              }, [
                _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.$t('General.PleaseChoose')), 1),
                _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t('PetData.GenderFemale')), 1),
                _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t('PetData.GenderMale')), 1)
              ], 8, _hoisted_40), [
                [_vModelSelect, _ctx.getDetailedPetData.gender]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('PetData.Birth')), 1),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_VueDatePicker, {
              id: "birth_id",
              modelValue: _ctx.getDetailedPetData.birth,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = ($event: any) => ((_ctx.getDetailedPetData.birth) = $event)),
                _ctx.updateAge
              ],
              placeholder: _ctx.$t('General.PleaseSelectDate'),
              "model-type": "yyyy-MM-dd",
              "auto-apply": "",
              "min-date": new Date(1950, 0, 1),
              "max-date": new Date(),
              "enable-time-picker": false,
              "prevent-min-max-navigation": "",
              format: "yyyy-MM-dd",
              disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType !== 'manager')
            }, null, 8, ["modelValue", "placeholder", "min-date", "max-date", "onUpdate:modelValue", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('PetData.Age')), 1),
          _createElementVNode("div", _hoisted_51, [
            (_ctx.ageYears == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.ageYears) + " " + _toDisplayString(_ctx.$t('General.Year')), 1))
              : _createCommentVNode("", true),
            (_ctx.ageYears > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.ageYears) + " " + _toDisplayString(_ctx.$t('General.Years')), 1))
              : _createCommentVNode("", true),
            (_ctx.ageMonths == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.ageMonths) + " " + _toDisplayString(_ctx.$t('General.Month')), 1))
              : _createCommentVNode("", true),
            (_ctx.ageMonths > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.ageMonths) + " " + _toDisplayString(_ctx.$t('General.Months')), 1))
              : _createCommentVNode("", true),
            ((_ctx.ageYears == 0 && _ctx.ageMonths == 0 && _ctx.ageDays == 1))
              ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.ageDays) + " " + _toDisplayString(_ctx.$t('General.Day')), 1))
              : _createCommentVNode("", true),
            ((_ctx.ageYears == 0 && _ctx.ageMonths == 0 && _ctx.ageDays > 1))
              ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.ageDays) + " " + _toDisplayString(_ctx.$t('General.Days')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('PetData.FertileStatus')), 1),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.getDetailedPetData.fertile_status) = $event)),
                required: "",
                class: "px-6",
                disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType === 'customer')
              }, [
                _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.$t('General.PleaseChoose')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fertileStatusOptions, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.value,
                    value: option.value
                  }, _toDisplayString(option.text), 9, _hoisted_65))
                }), 128))
              ], 8, _hoisted_63), [
                [_vModelSelect, _ctx.getDetailedPetData.fertile_status]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('PetData.Weight')), 1),
          _createElementVNode("div", _hoisted_69, [
            _withDirectives(_createElementVNode("input", {
              min: "0",
              max: "999",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.getDetailedPetData.weight) = $event)),
              step: "0.1",
              class: "input",
              type: "number",
              placeholder: _ctx.$t('PetData.WeightPlaceholder'),
              required: "",
              disabled: !_ctx.getEditingCustomer || (_ctx.getEditedCustEditingPet && _ctx.getAccessType === 'customer')
            }, null, 8, _hoisted_70), [
              [_vModelText, _ctx.getDetailedPetData.weight]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      (!_ctx.getEditedCustEditingPet)
        ? (_openBlock(), _createElementBlock("p", _hoisted_72, [
            _createElementVNode("button", {
              class: "button is-primary",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.iniPetEditing && _ctx.iniPetEditing(...args)))
            }, _toDisplayString(_ctx.$t('General.ModifyData')), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.getEditedCustEditingPet)
        ? (_openBlock(), _createElementBlock("p", _hoisted_73, [
            _createElementVNode("button", {
              class: "button is-primary",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.endShowingPetRecordMeth && _ctx.endShowingPetRecordMeth(...args)))
            }, _toDisplayString(_ctx.$t('General.Back')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.getEditedCustEditingPet)
        ? (_openBlock(), _createElementBlock("p", _hoisted_74, [
            _createElementVNode("button", _hoisted_75, _toDisplayString(_ctx.$t('General.Save')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.getEditedCustEditingPet)
        ? (_openBlock(), _createElementBlock("p", _hoisted_76, [
            _createElementVNode("a", {
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.cancelEditingPet && _ctx.cancelEditingPet(...args))),
              class: "button is-light"
            }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        (!_ctx.getEditingCustomer)
          ? (_openBlock(), _createElementBlock("table", _hoisted_79, [
              _createElementVNode("thead", _hoisted_80, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_81, _toDisplayString(_ctx.$t('AppointmentData.Appointment')), 1),
                  _createElementVNode("th", _hoisted_82, _toDisplayString(_ctx.$t('AppointmentData.Vet')), 1),
                  _createElementVNode("th", _hoisted_83, _toDisplayString(_ctx.$t('AppointmentData.Status')), 1),
                  _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.$t('AppointmentData.StatusTime')), 1),
                  _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.$t('AppointmentData.Link')), 1),
                  _hoisted_86
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPetRecord, (appointment) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: appointment.appointment_id
                  }, [
                    _createVNode(_component_AppointmentDataPetRecordTableRow, { "appointment-data": appointment }, null, 8, ["appointment-data"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}